// eslint-disable-next-line prefer-const
let searchInput = '';
export default {
    searchInput,
};
